// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i6wWE","type":"styles_type__LSOzP","choices":"styles_choices__2LcDN"};